<script context="module">"use strict";
let counter = 0;
</script>

<script>import { combineValidators } from '../validation';
import FieldTemplate from './FieldTemplate.svelte';
export let type = 'text', name = `input${type}_${counter++}`, label = '', inputStyle = '', cssClass = '', containerCssClass = '', placeholder = null, value = null, error = null;
export let id = `input_${type}_${name}`;
const typeAction = (node) => {
    node.type = type;
};
export let validators = [];
export const validate = async () => {
    try {
        await combineValidators(...validators)(label, value);
        error = null;
    }
    catch (e) {
        const errorObject = e;
        error = errorObject.message || 'Unknown error';
        throw e;
    }
};
</script>

<FieldTemplate {id} {label} {error} cssClass={containerCssClass}>
    <input
        style={inputStyle}
        use:typeAction
        slot="field"
        bind:value
        {id}
        {name}
        {placeholder}
        class={cssClass}
        class:validation_error={error}
    />
</FieldTemplate>

<style>
</style>
